import { CodeXml } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const CodeIcon = DeckardIconWrapper({ Icon: CodeXml });
